export default "__VITE_PUBLIC_ASSET__9142b39c__"